module.exports = __webpack_public_path__ + "0b7d00a42c02dcee4405ca84ac7a584f.MP3";